import React, { Suspense } from "react";
import {
  publicRoutes,
  withoutHeaderRoutes,
  dashboardRoutes,
} from "./router-link";
import { Outlet, Route, Routes } from "react-router-dom";
import Header from "../app/components/header";
import Footer from "../app/components/footer";
import DashboardLayout from "../app/components/dashboard-layout";
import { DashboardMenuProps } from "../app/components/dashboard-menu";
import { all_routes } from "./all-routes";
import Loader from "../loader/loader";
import { PrivateRoute, PublicRoute } from "./routes-guards";
import {
  DashboardOutlined,
  CommentOutlined,
  PictureOutlined,
  PhoneOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { useTokenExpirationMonitor } from "../app/hooks/useTokenExpirationMonitor";
import ScrollToTop from "../app/components/scroll-to-top";

const AllRoutes = () => {
  const routes = all_routes;

  // Monitor token expiration globally
  useTokenExpirationMonitor();
  const HeaderLayout = () => (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );

  const links: DashboardMenuProps[] = [
    {
      to: routes.dashboard,
      src: <DashboardOutlined style={{ fontSize: "18px" }} />,
      title: "Dashboard",
    },
    {
      to: routes.contacts,
      src: <PhoneOutlined style={{ fontSize: "18px" }} />,
      title: "Contact Us",
    },
    {
      to: routes.dashboardVideos,
      src: <VideoCameraOutlined style={{ fontSize: "18px" }} />,
      title: "Videos",
    },
    {
      to: routes.dashboardTestimonials,
      src: <CommentOutlined style={{ fontSize: "18px" }} />,
      title: "Testimonials",
    },
    {
      to: routes.dashboardGallery,
      src: <PictureOutlined style={{ fontSize: "18px" }} />,
      title: "Gallery",
    },
  ];
  return (
    <Suspense fallback={<Loader />}>
      <ScrollToTop />
      <Routes>
        {/* Public routes - accessible to everyone (logged in or not) */}
        <Route element={<HeaderLayout />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>

        {/* Protected dashboard routes - only for authenticated users */}
        <Route element={<PrivateRoute />}>
          <Route element={<DashboardLayout links={links} />}>
            {dashboardRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} key={idx} />
            ))}
          </Route>
        </Route>

        {/* Auth pages (login, register, etc.) - only for unauthenticated users */}
        <Route element={<PublicRoute />}>
          {withoutHeaderRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AllRoutes;
